$(function(){
    $('#refreshTracking').on('click', function(){
        $('#trackingList')
            .html('Loading....')
            .load(window.app.loadTrackingListRoute, function(){
            updateShipButton();
        });
    });
});

function addTrackingItem(){
    let carrier                 = $('#ship_carrier option:selected').text();
    let method                  = $('#ship_method option:selected').text();
    let methodID                = $('#ship_method').val();
    let tracking                = $('#tracking_num').val();
    let truckName               = $('#truckName').val();
    let billOfLading            = $('#billOfLading').val();
    let shippingID              = $('#shippingID').val();
    let cost                    = $('#shippingCost').val();
    let shipmentID              = $('#shipmentID').val();
    let shipStationShipmentID   = $('#shipStationShipmentID').val();
    let saturday        = $('#saturdayDelivery').is(':checked') ? 1 : 0;
    let markup          = $('#markupCost').is(':checked') ? 1 : 0;
    let includeInstallKit= $('#includeInstallKit').is(':checked') ? 1 : 0;
    let includeInstruction= $('#includeInstruction').is(':checked') ? 1 : 0;
    let shippingAddressID       = $('#shippingAddress').val();
    let baseName         = 'orders-shipping[' + trackingCount + ']';

    let label = carrier + ' ' + method;
    if(tracking){
        label = tracking + ' ' + label;
    }

    let trackingListItem = getTrackingListItem();

    trackingListItem.find('.shipping-methodID')
        .attr('name', baseName + '[methodID]')
        .val(methodID);

    trackingListItem.find('.shipping-tracking')
        .attr('name', baseName + '[tracking]')
        .val(tracking);

    trackingListItem.find('.shipping-truckName')
        .attr('name', baseName + '[truckName]')
        .val(truckName);

    trackingListItem.find('.shipping-billOfLading')
        .attr('name', baseName + '[billOfLading]')
        .val(billOfLading);

    trackingListItem.find('.shipping-items')
        .attr('name', baseName + '[orders-shipping-item][0]')
        .val('');

    trackingListItem.find('.saturday-delivery')
        .attr('name', baseName + '[saturdayDelivery][0]')
        .val(saturday);

    trackingListItem.find('.markup-cost')
        .attr('name', baseName + '[markup][0]')
        .val(markup);

    trackingListItem.find('.include-install-kit')
        .attr('name', baseName + '[includeInstallKit][0]')
        .val(includeInstallKit);

    trackingListItem.find('.include-instruction')
        .attr('name', baseName + '[includeInstruction][0]')
        .val(includeInstruction);

    trackingListItem.find('.shipping-address-id')
        .attr('name', baseName + '[shippingAddressID]')
        .val(shippingAddressID);

    trackingListItem.find('.shipping-existing-label').text(label);
    trackingListItem.find('.shipping-count').val(trackingCount);
    trackingListItem.find('.shipping-carrier').val(carrier);
    trackingListItem.find('.shipping-cost').val(cost);
    trackingListItem.find('.shipment-id').val(shipmentID);
    trackingListItem.find('.ship-station-shipment-id').val(shipStationShipmentID);

    let shipStationURL = '';
    if(shipStationShipmentID != ''){
        shipStationURL = window.app.shipStationOrderLink.replace('SHIPMENT_NUMBER', window.app.orderNum + '-' + shippingID);

        trackingListItem.find('.ship-station-order-link').prop('href', shipStationURL);
        if(tracking == '')
            trackingListItem.find('.ship-station-tracking').attr('data-id', shippingID);
        else
            trackingListItem.find('.ship-station-get-tracking-container').remove();
    }
    else
        trackingListItem.find('.ship-station-shipment-container').remove();

    trackingListItem.attr({
        id: 'listItem' + trackingCount,
        class: 'list-group-item'
    });

    trackingListItem.find('.shipping-id').remove();
    if(shippingID > 0){
        trackingListItem.append(
            $('<input>').attr({
                type: 'hidden',
                class: 'shipping-id',
                name: baseName + '[id]',
                value: shippingID
            })
        );
    }

    trackingListItem.find('.shipping-updated').remove();
    trackingListItem.append(
        $('<input>').attr({
            type: 'hidden',
            name: baseName + '[updated]',
            class: 'shipping-updated',
            value: 1
        })
    );

    removeTrackingItems(trackingListItem, false);
    addTrackingItems(trackingListItem);
    addShippingNotification(shippingID);

    $('#trackingList').append(trackingListItem);
    updateShipButton();

    trackingCount++;
    $('#trackingListContainer').show();
    clearTrackingInputs();

    if(shipStationURL != '')
        window.open(shipStationURL, '_blank').focus();
}

function getTrackingListItem(){
    let shippingCount = $('#shippingCount').val();
    let listItem = '';

    if(shippingCount != '')
        listItem = $('#listItem' + shippingCount);
    else
        listItem = createEmptyTrackingListItem();

    return listItem;
}

function createEmptyTrackingListItem(){
    let listItem = $('<li>').attr({
        id: 'listItem0',
        class: 'list-group-item'
    });

    // add label and edit/remove
    listItem.append(
        $('<span>').attr({
            class: 'shipping-existing-label'
        })
    ).append(
        $('<button>').attr({
            class: 'edit-tracking btn-ghost',
        }).append(
            $('<i>').attr({
                class: 'fa-solid fa-pencil',
                'aria-hidden': 'true'
            })
        )
    ).append(
        $('<button>').attr({
            class: 'remove-tracking btn-ghost-danger',
        }).append(
            $('<i>').attr({
                class: 'fa-solid fa-xmark',
                'aria-hidden': 'true'
            })
        )
    ).append(
        $('<span>').attr({
            class: 'ship-station-shipment-container'
        }).append(
            $('<a>').attr({
                class: 'ship-station-order-link',
                target: '_blank'
            }).append('View on Ship Station')
        ).append(
            $('<span>').attr({
                class: 'ship-station-get-tracking-container'
            }).append(
                '&nbsp;|&nbsp;'
            ).append(
                $('<a>').attr({
                    href: '#',
                    class: 'ship-station-tracking'
                }).append(
                    'Get Tracking from Ship Station'
                )
            ).append(
                $('<span>').attr({
                    class: 'ship-station-tracking-message'
                })
            )
        )
    );

    // add inputs
    // note- I don't need to put name attr, because it changes.  Also, no value since this is an empty item
    listItem.append(
        $('<input>').attr({
            type: 'hidden',
            class: 'shipping-count',
            value: 0
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'shipping-cost'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'shipping-id'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'shipping-methodID'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'shipping-carrier'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'shipping-tracking'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'shipping-truckingName'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'shipping-items'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'shipment-id'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'ship-station-shipment-id'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'markup-cost'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'saturday-delivery'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'include-install-kit'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'include-instruction'
        })
    ).append(
        $('<input>').attr({
            type: 'hidden',
            class: 'shipping-address-id'
        })
    );

    // add product list
    listItem.append(
        $('<div>').attr({
            class: 'row'
        }).append(
            $('<div>').attr({
                class: 'col-xs-12'
            }).append(
                $('<ul>').attr({
                    class: 'product-list'
                })
            )
        )
    );

    return listItem;
}

function removeTrackingItems(trackingListItem, updateQuantity){
    var shippingCountContainer      = $('#shippingCount');
    var shippingCountEditContainer  = trackingListItem.find('.shipping-count');
    var isItemsUpdated              = shippingCountContainer.val() == shippingCountEditContainer.val();

    trackingListItem.find('.product-list > li').each(function(index) {
        if(updateQuantity && !isItemsUpdated)
            updateItemQuantity($(this).data('itemnodeid'), $(this).data('quantity'), true, true, true);

        $(this).remove();
    });
    trackingListItem.find('.item-input').empty();
}

function findRootContainer(clickedInput){
    return clickedInput.closest('tbody').find('tr.root-node');
}

function setRootContainerQuantityAsLowest(rootContainer, lowestQuantity){
    let quantityInput = rootContainer.find('input.item-quantity');
    let availability = rootContainer.find('td.shipping-available');
    quantityInput.prop('value', lowestQuantity);
    quantityInput.attr('max', lowestQuantity);
    availability.html(lowestQuantity);

    if(lowestQuantity === 0)
        rootContainer.find('input.item').prop('disabled', true);
    else
        rootContainer.find('input.item').prop('disabled', false);
}

function updateParentQuantityExceptRoot(clickedItem){
    let container = clickedItem.closest('tr');

    if(container.hasClass('root-node') || container.hasClass('ignore-node'))
        return false;

    while(true){
        let lowestNumOfChildren = null;
        let parentNodeId = container.data('parentnodeid');
        container = $('#container' + parentNodeId);

        if(container.hasClass('ignore-node'))
            return;

        $('.' + parentNodeId).each(function(){
            let childQuantity = $(this).find('input.item-quantity-child-node').val();
            childQuantity = Number(childQuantity);

            if(lowestNumOfChildren === null || childQuantity < lowestNumOfChildren)
                lowestNumOfChildren = childQuantity;
        });

        let parentQuantity = container.find('input.item-quantity-child-node');
        let parentAvailability = container.find('div.shipping-available');
        let parentCheckbox = container.find('input.item-child-node')
        parentQuantity.prop('value', lowestNumOfChildren);
        parentQuantity.attr('max', lowestNumOfChildren);
        parentAvailability.text(lowestNumOfChildren);

        if(lowestNumOfChildren === 0)
            parentCheckbox.prop('disabled', true);
        else
            parentCheckbox.prop('disabled', false);

        if(container.hasClass('root-node'))
            break;
    }
}

function findLowestQuantity(clickedInput){
    let foundParent= false;
    let lowestQuantity = null;

    clickedInput.closest('tbody.mainContainer').find('tr').each(function(){
        if($(this).hasClass('ignore-node'))
            return;

        if($(this).hasClass('root-node') && !foundParent)
            foundParent = true;
        else if(foundParent && $(this).hasClass('root-node'))
            return false;
        else{
            $(this).find('.item-quantity-child-node').each(function (){
                if(lowestQuantity === null || Number($(this).val()) < Number(lowestQuantity))
                    lowestQuantity = $(this).val();
            });
        }
    });

    return Number(lowestQuantity);
}

function updateItemQuantity(itemNodeID, quantity, add, updateParent = false, updateChildren = false){
    let shippingAvailable = $('#shippingAvailable' + itemNodeID);
    let available = parseInt(shippingAvailable.text());
    quantity = parseInt(quantity);

    if(add)
        available += quantity;
    else
        available -= quantity;

    let itemNodeRow = $('#container' + itemNodeID);

    setQuantityInputs(itemNodeID, available, itemNodeRow, shippingAvailable);

    if(updateChildren)
        updateChildrenQuantity(itemNodeID, quantity, add);

    if(updateParent)
        updateParentQuantity(itemNodeID, itemNodeRow, available);
}

function setQuantityInputs(itemNodeID, newQuantity, itemNodeRow, availableContainer){
    availableContainer.text(newQuantity);

    let disable = newQuantity < 1;
    let checkbox        = itemNodeRow.find('.item-checkbox');
    let quantityInput   = itemNodeRow.find('.item-quantity');

    checkbox.prop('disabled', disable);
    quantityInput.prop('disabled', true).val(newQuantity);
    quantityInput.attr('max', newQuantity);
}

function updateChildrenQuantity(itemNodeID, quantity, add){
    $('.' + itemNodeID + '.childNode').each(function(){
        let childItemNodeID = $(this).data('itemnodeid');
        let childQuantityUpdate = quantity * $(this).data('cascadingquantity');
        updateItemQuantity(childItemNodeID, childQuantityUpdate, add);
        updateChildrenQuantity(childItemNodeID, childQuantityUpdate, add);
    });
}

function updateParentQuantity(itemNodeID, itemNodeRow, newQuantity){
    let parentItemNodeID = itemNodeRow.data('parentnodeid');
    if(parentItemNodeID === undefined)
        return false;

    let newParentQuantity = null;
    $('.' + parentItemNodeID + '.childNode').each(function(){
        let childQuantity       = $(this).find('.item-quantity').val();
        let cascadingQuantity   = $(this).data('cascadingquantity');
        let allowedParentQuantity = Math.floor(childQuantity / cascadingQuantity);

        if(newParentQuantity === null || allowedParentQuantity < newParentQuantity)
            newParentQuantity = allowedParentQuantity;
    });

    let parent = $('#container' + parentItemNodeID);

    setQuantityInputs(parentItemNodeID, newParentQuantity, parent, parent.find('.shipping-available'));
    updateParentQuantity(parentItemNodeID, parent, newParentQuantity);
}

function addTrackingItems(trackingListItem){
    trackingListItem.find('.item-input').remove();

    var count = 0;
    $('#itemTable').find('input:checked').each(function(){
        if($(this).attr('name') !== 'status') {
            var itemNodeID = $(this).val();
            var quantity  = $('#quantity' + itemNodeID).val();
            var itemName  = $('#itemName' + itemNodeID).text();
            var sizeLabel = $(this).data('sizelabel');
            var label = '';

            if(itemName.indexOf(sizeLabel) !== -1)
                label = itemName;
            else
                label = sizeLabel + ' ' +  itemName;

            if(quantity == null)
                quantity = $('#quantityChildNode' + itemNodeID).val();

            if(quantity != null){
                var name = 'orders-shipping[' + trackingCount + '][orders-shipping-item-node][' + count + ']';
                trackingListItem.find('.product-list').append(
                    $('<li>').attr({
                        'data-itemnodeid': itemNodeID,
                        'data-quantity': quantity
                    }).append(label + ' - ' + quantity)
                );

                trackingListItem.append(
                    $('<input>').attr({
                        type: 'hidden',
                        class: 'item-input',
                        name: name + '[itemNodeID]',
                        value: itemNodeID
                    })
                ).append(
                    $('<input>').attr({
                        type: 'hidden',
                        class: 'item-input',
                        name: name + '[quantity]',
                        value: quantity
                    })
                );

                updateItemQuantity(itemNodeID, quantity, false, true, true);

                count++;
            }

            $('#itemTable').find('input:disabled').each(function (){
                itemNodeID = $(this).val();
                itemName = $('#itemName' + itemNodeID).text();
                var parentQuantity = $('#quantity' + itemNodeID).val();
                var childQuantity = $('#quantityChildNode' + itemNodeID).val();

                if(itemName == null || itemName === '')
                    return;

                if(parentQuantity == 0 || childQuantity == 0 )
                    return;

                if($(this).attr('name') !== 'status') {
                    name = 'orders-shipping[' + trackingCount + '][orders-shipping-item-node][' + count + ']';

                    trackingListItem.append(
                        $('<input>').attr({
                            type: 'hidden',
                            class: 'item-input',
                            name: name + '[itemNodeID]',
                            value: itemNodeID
                        })
                    ).append(
                        $('<input>').attr({
                            type: 'hidden',
                            class: 'item-input',
                            name: name + '[quantity]',
                            value: quantity
                        })
                    );

                    updateItemQuantity(itemNodeID, quantity, false);
                    count++;
                }
            });
        }
    });
}

function clearTrackingInputs(){
    $('#tracking_num').val('');
    $('#billOfLading').val('');
    $('#truckName').val('');
    $('#shippingID').val(0);
    $('#shippingCount').val('');
    $('#shippingCost').val('');
    $('#saturdayDelivery').prop('checked', false);
    $('#includeInstruction').prop('checked', false);
    $('#includeInstallKit').prop('checked', false);
    $('#shipmentID').val('');
    $('#itemTable').find('input:checkbox').each(function(index){
        $(this).prop('checked', false);
    });
    $('#itemTable').find("input[type='number']").each(function(index){
        $(this).prop('disabled', true);
    });
}

function editTracking(editButton){
    var trackingListItem            = $(editButton).closest('.list-group-item');
    var shippingCountContainer      = $('#shippingCount');
    var shippingCountEditContainer  = trackingListItem.find('.shipping-count');
    if(shippingCountContainer.val() != shippingCountEditContainer.val()) {
        rollbackItemList();

        $('#ship_carrier').val(trackingListItem.find('.shipping-carrier').val()).change();
        $('#shippingID').val(trackingListItem.find('.shipping-id').val());
        shippingCountContainer.val(shippingCountEditContainer.val());
        $('#tracking_num').val(trackingListItem.find('.shipping-tracking').val());
        $('#truckName').val(trackingListItem.find('.shipping-truckName').val());
        $('#billOfLading').val(trackingListItem.find('.shipping-billOfLading').val());
        $('#ship_method').val(trackingListItem.find('.shipping-methodID').val());
        $('#shippingCost').val(trackingListItem.find('.shipping-cost').val());
        $('#shipmentID').val(trackingListItem.find('.shipment-id').val());
        $('#shippingAddress').val(trackingListItem.find('.shipping-address-id').val()).change();

        var checked = trackingListItem.find('.saturday-delivery').val() > 0 ? true : false;
        $('#saturdayDelivery').prop('checked', checked);

        checked = trackingListItem.find('.include-install-kit').val() > 0 ? true : false;
        $('#includeInstallKit').prop('checked', checked);

        checked = trackingListItem.find('.include-instruction').val() > 0 ? true : false;
        $('#includeInstruction').prop('checked', checked);

        checked = trackingListItem.find('.markup-cost').val() > 0 ? true : false;
        $('#markupCost').prop('checked', checked);

        trackingListItem.find('.product-list > li').each(function (index) {
            var itemNodeID = $(this).data('itemnodeid');
            var quantity = $(this).data('quantity');

            let clickedInput = $('#trackingItem' + itemNodeID);
            let clickedQuantity = $('#quantity' + itemNodeID);

            if(clickedInput.length === 0)
                clickedInput = $('#childNode' + itemNodeID);

            if(clickedQuantity.length === 0)
                clickedQuantity = $('#quantityChildNode' + itemNodeID);

            clickedInput.prop('checked', true);
            updateItemQuantity(itemNodeID, quantity, true, true, true);
            clickedQuantity.prop('disabled', false).val(quantity);
        });

        let itemNodeID = trackingListItem.find('.item-node-id').val();
        $('tr.' + itemNodeID).each(function(){
            let checkbox = $(this).find('input:checkbox');
            checkbox.prop('disabled', true);
        });
    }
}

function rollbackItemList(){
    var shippingCount = $('#shippingCount').val();
    var listItem = $('#listItem' + shippingCount);

    if(listItem){
        listItem.find('.product-list > li').each(function(index){
            var itemNodeID = $(this).data('itemnodeid');
            var quantity   = $(this).data('quantity');

            updateItemQuantity(itemNodeID, quantity, false, true, true);
        });
    }
}

function addShippingNotification(shippingID){
    var shippingForm = $('#ship');
    if(shippingForm.find('#shippingNotification' + shippingID).length == 0) {
        shippingForm.append(
            $('<input>').attr({
                type: 'hidden',
                id: 'shippingNotification' + shippingID,
                name: 'orderShippingIDs[]',
                value: shippingID
            })
        );
    }
}

function removeShippingNotification(shippingID){
    $('#ship').find('#shippingNotification' + shippingID).remove();
}

function updateShipButton(){
    $('#save').prop("disabled", !shouldEnableShipButton());
}

/*
 * There should be at least one OrderShipping (list-group-item) and the tracking must exist unless the carrier
 * allows no tracking.
 */
function shouldEnableShipButton(){
    // check that there is at least one shipping item and that there is a tracking number for each carrier where tracking is required
    let trackingList = $('#trackingList')
    if(trackingList.find('.list-group-item').length === 0)
        return false;

    let shouldEnable = true;
    trackingList.find('.list-group-item').each(function(){
        let carrierName = $(this).find('.shipping-carrier').val();
        let tracking = $(this).find('.shipping-tracking').val();

        if(tracking == '' && !window.app.trackingNotRequiredCarriers.includes(carrierName))
            shouldEnable = false;
    });

    return shouldEnable;
}

window.app.fns.removeShippingNotification = removeShippingNotification;
window.app.fns.removeTrackingItems = removeTrackingItems;
window.app.fns.addTrackingItem = addTrackingItem;
window.app.fns.editTracking = editTracking;
window.app.fns.rollbackItemList = rollbackItemList;
window.app.fns.addShippingNotification = addShippingNotification;
window.app.fns.removeShippingNotification = removeShippingNotification;